import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { Text } from '../../text/text';

const Container = styled.div`

    margin-bottom: ${(props) => (props.inline ? '1rem' : 'inherit')};
    div:first-child {
        display: ${(props) => (props.inline ? 'inline-block' : 'flex')};
        flex-wrap: nowrap;
    }
`;
/**
 * Displays the 1st month price, and total price of a specific quote inline
 * @param {Number} firstMonth The firstMonth price
 * @param {Number} total The total price
 * @returns {Node} PriceDetails Returns the PriceDetails
 * @constructor
 */
const PriceDetails = ({ firstMonth, total, column }) => {
    const displayMode = useSelector((state) => resultsConfigSelector(state).get('displayMode'));
    const isFeaturesView = displayMode === 'column';
    const currentBreakpoint = pageContext.getProps().pageState.breakpoint;

    // use inlineBlock for display if breakpoint is lg or less and inside features view
    const inlineBlock = ['xs', 'sm', 'md', 'lg'].includes(currentBreakpoint) && isFeaturesView;
    return (
        <Container inline={inlineBlock}>
            <SimpleFlexbox display="flex" column={column} contentAround="xs" wrap margin="left" inlineBlock>
                <SimpleFlexbox margin="right_small">
                    <Text variant="white_space_nowrap">
                        <Text size="small" color="brand_base_120">1st Month: </Text>
                        <Text size="small" color="brand_base_80" prefix="$">{firstMonth.toFixed(2)}</Text>
                    </Text>
                </SimpleFlexbox>
                <SimpleFlexbox margin="right_small">
                    <Text variant="white_space_nowrap">
                        <Text size="small" color="brand_base_120"> TOTAL: </Text>
                        <Text size="small" color="brand_base_80" prefix="$">{total.toFixed(2)}</Text>
                    </Text>
                </SimpleFlexbox>
            </SimpleFlexbox>
        </Container>

    );
};

PriceDetails.propTypes = {
    firstMonth: PropTypes.number,
    total: PropTypes.number,
    column: PropTypes.bool
};

PriceDetails.defaultProps = {
    firstMonth: 0.0,
    total: 0.0,
    column: true
};

export { PriceDetails };
